'use client'

import { createContext, useContext, useMemo } from 'react'
import { Color } from 'three'

// Define your palette configuration here.
// Using Hex codes for simpler management and exact matching with source data.
export const PALETTE_CONFIG = [
    { id: 'red1', label: 'Red 1', base: new Color('#FF3E5F') },
    { id: 'red2', label: 'Red 2', base: new Color('#ff0000') },
    { id: 'yellow1', label: 'Yellow 1', base: new Color('#FFD82F') },
    { id: 'gold', label: 'Gold', base: new Color('#FFB254') },
    { id: 'white', label: 'White', base: new Color('#ffffff') },
    { id: 'offwhite', label: 'Off White', base: new Color('#FFF3DB') },
    { id: 'stone1', label: 'Stone 1', base: new Color('#50555B') },
    { id: 'stone2', label: 'Stone 2', base: new Color('#B5C3CE') },
    { id: 'green1', label: 'Green 1', base: new Color('#00ff00') },
    { id: 'green2', label: 'Green 2', base: new Color('#6F978E') },
    { id: 'black1', label: 'Metal Black', base: new Color('#1a1a1a') },
    { id: 'blue1', label: 'Blue 1', base: new Color('#4F6AFF') },
    { id: 'pink1', label: 'Pink 1', base: new Color('#ffa3f6') },
    { id: 'pink2', label: 'Pink 2', base: new Color('#FFDDE3') },
]

// Keep a static reference for defaults
export const BASE_PALETTE_DEFAULTS = PALETTE_CONFIG.map((c) => c.base)

const PaletteContext = createContext({
    baseColors: BASE_PALETTE_DEFAULTS,
    paletteColors: BASE_PALETTE_DEFAULTS,
})

export function PaletteProvider({ children }) {
    // Both base and palette colors are now static (no Leva overrides)
    const value = useMemo(
        () => ({
            baseColors: BASE_PALETTE_DEFAULTS,
            paletteColors: BASE_PALETTE_DEFAULTS,
        }),
        [],
    )

    return <PaletteContext.Provider value={value}>{children}</PaletteContext.Provider>
}

export function usePalette() {
    return useContext(PaletteContext)
}
